<template>
  <div class="form-control">
    <template v-if="!isEdit">
      <slot></slot>
      <a
        href="javascript:void(0);"
        @click="isEdit = true"
        v-if="$store.getters.getPackage == 'premium' && !isCoachlab"
      >
        <span class="fas fa-pencil-alt"></span>
      </a>
    </template>
    <template v-else>
      <input
        type="text"
        class="form-control"
        :placeholder="placeholder"
        v-model="customer_value"
        maxlength="600"
      />
      <div class="text-xs-center">
        <v-btn outline color="grey" small @click="cancelEdit">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" small @click="saveEdit">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: undefined
    },
    userid: {
      default: undefined
    },
    placeholder: {
      default: ''
    }
  },
  data: function() {
    return {
      isEdit: false,
      customer_value: ''
    }
  },
  mounted: function() {
    this.customer_value = this.value
    this.cached_customer_value = this.value
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    })
  },
  methods: {
    cancelEdit: function() {
      this.isEdit = false
      this.customer_value = this.cached_customer_value
    },
    saveEdit: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.userid,
        customer_value: vm.customer_value,
        onEdit: function() {
          vm.isEdit = false
          vm.cached_customer_value = vm.customer_value
          vm.$emit('input', vm.customer_value)
        }
      }
      vm.$emit('onEdit', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/EditCustomerValue.vue